import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { HiLocationMarker, HiPhone, HiMail, } from 'react-icons/hi';
import AyelDarkLogo from '../../Assets/images/ayel_dark.png';
import { Link, useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const quickLinks = [
    { title: "Home", link: "/" },
    { title: "Services", link: "/services" },
    { title: "About Us", link: "/about" },
    { title: "Contact", link: "/contact" }
  ];

  const socialLinks = [
    // { icon: <FaFacebookF />, link: "#" },
    // { icon: <FaTwitter />, link: "#" },
    { icon: <FaInstagram />, link: "https://www.instagram.com/ayelmarineltd/" },
    { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/company/ayel-marine-electronics/" }
  ];

  return (
    <footer className="bg-gradient-to-b from-marine-black to-black text-white font-tt-lakes relative">
     
      <div className="absolute top-0 left-0 right-0 h-4 bg-marine-red opacity-10 transform -translate-y-1/2"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          
          <div className="space-y-6">
            <div className="flex items-center space-x-2">
            <img 
                src={AyelDarkLogo} 
                alt="Ayel Marine Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 leading-relaxed">
              Over 20 years of experience in professional maritime and port services.
            </p>
            <div className="flex space-x-5">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.link}
                  className="text-gray-400 hover:text-marine-red transform hover:scale-110 transition-all duration-300 text-xl"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

         
          <div>
            <h3 className="text-xl font-semibold mb-6 text-marine-red">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.link}
                    className="text-gray-300 hover:text-marine-red transition-colors duration-300 flex items-center group"
                  >
                    <span className="transform group-hover:translate-x-2 transition-transform duration-300">
                      {link.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

         
          <div>
            <h3 className="text-xl font-semibold mb-6 text-marine-red">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3 group">
                <HiLocationMarker className="w-6 h-6 text-gray-400 group-hover:text-marine-red mt-1" />
                <div className="text-gray-300">
                  Yayla Mahallesi Pınar Sokak
                  <br />
                  NO :5/A 34944 TUZLA İSTANBUL
                </div>
              </div>
              <div className="flex items-center space-x-3 group">
                <HiPhone className="w-6 h-6 text-gray-400 group-hover:text-marine-red" />
                <span className="text-gray-300">+90 (216) 888 81 69</span>
              </div>
              <a 
                href="https://wa.me/905522065415" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-3 group hover:text-marine-red transition-colors duration-300"
              >
                <FaWhatsapp className="w-6 h-6 text-gray-400 group-hover:text-marine-red" />
                <span className="text-gray-300 group-hover:text-marine-red">+90 552 206 54 15</span>
              </a>
              <div className="flex items-center space-x-3 group">
                <HiMail className="w-6 h-6 text-gray-400 group-hover:text-marine-red" />
                <span className="text-gray-300">service@ayelmarine.com</span>
              </div>
              <div className="flex items-center space-x-3 group">
                <HiMail className="w-6 h-6 text-gray-400 group-hover:text-marine-red" />
                <span className="text-gray-300">sales@ayelmarine.com</span>
              </div>
            </div>
          </div>
        </div>

       
        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} Ayel Marine. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;